module.exports = __webpack_public_path__ + "media/images/vouchers/algologie_rivage-3baf91186d105aaf70f3377ef5c3318d.png";